import moment from 'moment';
import React, { useState, useEffect } from 'react';

const ReceivedItemView = ({ itemData, currencyPrecision }) => {

    return (
        <div>
            <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "400px" }}>
                <table>
                    <thead className='dynoTable' >
                        <tr>
                            <th>Sr no</th>
                            <th>Item No</th>
                            <th>Description</th>
                            <th>Item Specs</th>
                            <th>Qty</th>
                            <th>Inventory UOM</th>
                            <th>Unit Price</th>
                            <th>Amount</th>
                            <th>Received</th>
                            <th>Received Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {itemData?.issueDetails?.map((row, index) => (
                            <tr key={index}>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.srno} disabled style={{ width: "140px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.itemCode} style={{ width: "130px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.itemDescription} style={{ width: "150px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.specification} style={{ width: "150px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.qty} style={{ width: "140px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' value={row.uom} disabled style={{ width: "140px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' value={Number(row.unitPrice).toFixed(currencyPrecision || 0)} disabled style={{ width: "140px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' value={Number(row.amount).toFixed(currencyPrecision || 0)} disabled style={{ width: "140px" }} /></td>
                                <td className='m-0 p-0'><div className='center'>
                                    <input className='px-2 form-check-input' type="checkbox" disabled
                                        style={{ width: "26.81px", height: "26.81px" }} checked={row.received === 1 ? true : false} /> </div>
                                </td>
                                <td className='m-0 p-0'><input className='p-2'
                                    disabled
                                    type='datetime'
                                    value={moment(row?.receivedDate).format('DD-MMM-YYYY')}
                                    style={{ width: "140px" }} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ReceivedItemView;